// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "react-toastify" + "." + "d9aa1ba4cb165b860715" + ".bundle.js";
};